import * as Sentry from '@sentry/react'

const dsn = import.meta.env.VITE_SENTRY_DSN

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  })
}

export function setSentryUser(user: { id: string; email: string; role?: string }) {
  Sentry.setUser({ id: user.id, email: user.email, role: user.role })
}

export function clearSentryUser() {
  Sentry.setUser(null)
}

export function captureError(error: unknown, context?: Record<string, unknown>) {
  if (error instanceof Error) {
    Sentry.captureException(error, { extra: context })
  } else {
    Sentry.captureException(new Error(String(error)), { extra: context })
  }
}
